import { Card } from "antd";
import { Skeleton } from "common/components/skeleton/skeleton";
import { Flex } from "common/components/flex/flex";
import EmptyPlaceholder from "common/components/emptyPlaceholder/emptyPlaceholder";
import { CandidateLinkItem } from "features/dashboard/components/candidateLinkItem/candidateLinkItem";
import K from "utilities/constants";
import styles from "features/dashboard/sections/tasks/tasksContent/taskGroup/taskGroup.module.scss";
import { TaskGroupHeader } from "features/dashboard/sections/tasks/tasksContent/taskGroup/taskGroupHeader/taskGroupHeader";

export const TaskGroup = ({
  testId,
  label,
  description,
  icon,
  tasks,
  getStatus,
  getDueTime,
  getDueDate,
  loading = false,
}) => {
  const renderContent = () => {
    if (loading) {
      return <Skeleton paragraph={{ rows: 12, width: "100%" }} />;
    }

    return (
      <Flex direction="column" gap={8} className={styles.taskGroup__content}>
        <TaskGroupHeader
          testId={testId}
          icon={icon}
          label={label}
          description={description}
          count={tasks.length}
        />

        {tasks.length === 0 ? (
          <Flex justify="center">
            <EmptyPlaceholder description="No tasks found." />
          </Flex>
        ) : (
          <Flex
            direction="column"
            gap={8}
            className={`scrollable-container ${styles.taskGroup__list}`}
          >
            {tasks.map((task) => {
              const { id, candidate, job } = task;
              const status = getStatus(task);
              const dueTime = getDueTime?.(task);
              const dueDate = getDueDate?.(task);

              return (
                <CandidateLinkItem
                  key={id}
                  candidateId={candidate.id}
                  jobEntryId={id}
                  name={candidate.fullName}
                >
                  <span className="text-secondary">{job.title}</span>
                  <span className="font-style-italic">{status}</span>
                  {dueTime && <span>{dueTime}</span>}
                  {dueDate && (
                    <Flex
                      align="center"
                      gap={4}
                      style={{
                        color:
                          K.DaysInStatusAlertLevelColors[dueDate.alertLevel] ||
                          "inherit",
                      }}
                    >
                      <span>{dueDate.text}</span>
                    </Flex>
                  )}
                </CandidateLinkItem>
              );
            })}
          </Flex>
        )}
      </Flex>
    );
  };

  return <Card className={styles.taskGroup}>{renderContent()}</Card>;
};
